export const getApiUrl = (tier: string): string => {
  const path = '/brandfree-prepaid/api';
  if (tier === 'local' || tier === 'dev' || tier === 'test') {
    return path;
  }
  return `https://topup.telia.ee${path}`;
};
